<div class="searchResults" [class.extra]="extra">
  @if (loader) {
    <app-mini-loading></app-mini-loading>
  } @else {
    @if (experts?.length) {
      @for (item of experts; let i = $index; track item) {
        <button
          (click)="gotoprofile(item)"
          [class.mb-3]="experts?.length > 1 && i < experts.length - 1"
          class="d-flex align-items-center gap-3 btnWhite border-0 w-100"
        >
          <div class="profileImage oHideBox dCenter">
            <img
              defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
              [useSrcset]="true"
              [lazyLoad]="item?.profileImage"
              width="100%"
              height="100%"
              alt="search"
              class="lazyImage"
            />
          </div>
          <p class="mb-0">{{ item?.fullName }}</p>
        </button>
      }
    } @else {
      <div class="text-center">
        <p class="text-dark mt-3 mb-0 gilroy">
          Unfortunately, we couldn't find a creator with this name. If you'd
          like us to onboard your preferred creator, please share their name and
          any social media links with us. We'd be happy to help bring this
          amazing creator on board!
        </p>
        <button class="btnPrimary my-3" (click)="showAddCreator()">
          Add Creator Info
        </button>
      </div>
    }
  }
</div>
